import { Link } from "react-router-dom";
import { Instagram, Linkedin, Youtube, Zap } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="relative border-t border-white/10 bg-[#0a0a0f] py-10"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10 lg:px-12">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <div className="flex items-center gap-3">
            <span className="inline-flex h-8 w-8 items-center justify-center rounded-md border border-[#00d4ff]/40 bg-[#00d4ff]/10">
              <Zap className="h-4 w-4 text-[#00d4ff]" strokeWidth={2.5} />
            </span>
            <div>
              <div className="font-display text-base font-bold tracking-tight">
                AI <span className="text-[#00d4ff]">VOLTA</span>
              </div>
              <p className="text-xs text-zinc-500 mt-0.5">
                © 2026 AI Volta. Fort Lauderdale, FL.
              </p>
            </div>
          </div>

          <div className="flex items-center gap-8">
            <Link
              to="/privacy"
              data-testid="footer-link-privacy"
              className="text-sm text-zinc-400 hover:text-white transition-colors"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms"
              data-testid="footer-link-terms"
              className="text-sm text-zinc-400 hover:text-white transition-colors"
            >
              Terms of Service
            </Link>
          </div>

          <div className="flex items-center gap-3">
            <SocialLink href="#" label="LinkedIn" testId="footer-social-linkedin">
              <Linkedin className="h-4 w-4" />
            </SocialLink>
            <SocialLink href="#" label="Instagram" testId="footer-social-instagram">
              <Instagram className="h-4 w-4" />
            </SocialLink>
            <SocialLink href="#" label="YouTube" testId="footer-social-youtube">
              <Youtube className="h-4 w-4" />
            </SocialLink>
          </div>
        </div>
      </div>
    </footer>
  );
}

function SocialLink({ href, label, testId, children }) {
  return (
    <a
      href={href}
      aria-label={label}
      data-testid={testId}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-white/10 text-zinc-400 hover:text-[#00d4ff] hover:border-[#00d4ff]/40 hover:bg-[#00d4ff]/5 transition-colors"
    >
      {children}
    </a>
  );
}
